import { useTranslation } from 'react-i18next';

import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import * as State from 'components/desktop/Ingredient/IngredientState';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import CharacteristicRadioSelect from 'components/desktop/_general/CharacteristicSelect/CharacteristicRadioSelect';
import { showConfirmationDialog } from 'components/desktop/_general/ConfirmationDialog/ConfirmationDialog';
import { EAlertType } from 'enums/alertType';
import { Characteristic } from 'enums/characteristic';
import PERMISSIONS from 'enums/permissions';
import { fireAlert } from 'functions/fireAlert';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export const IngredientCharacteristicsCard = ({
	state,
	handlers,
}: IngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const isIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEINGREDIENT,
	]);

	const shouldRecalculate = async (): Promise<boolean> => {
		const answer = await showConfirmationDialog(
			t('alerts:ALERT_RECALCULATE'),
			t('alerts:ALERT_RECALCULATE_OK'),
			t('alerts:ALERT_RECALCULATE_NO')
		);
		return answer.isConfirmed;
	};

	const alertInvalidDensity = async (): Promise<void> => {
		fireAlert(
			EAlertType.danger,
			t('alerts:ALERT_INVALID_INPUT_DATA'),
			t('alerts:ALERT_DENSIITY_NOT_VALID')
		);
	};

	const successfulRecalculation = async (): Promise<void> => {
		await fireAlert(
			EAlertType.success,
			t('alerts:ALERT_RECALCULATE_AUTOMATIC_TITLE'),
			t('alerts:ALERT_RECALCULATE_AUTOMATIC_SUCCESS')
		);
	};

	return (
		<FoldableCard
			unlockable={isIngredientEditor}
			dataComponentType="ingredient-characteristics-card"
			defaultOpen={true}
			hasLock={true}
			defaultLocked={state.locked.characteristic}
			title={t('_general:CHARACTERISTICS')}
			handleLockClick={(input: boolean) =>
				input
					? handlers.restoreBaseIngredientKey('characteristic')
					: handlers.overwriteBaseIngredientKey('characteristic')
			}
			content={
				<div className="card-body">
					<CharacteristicRadioSelect
						checked={State.getCharacteristic(state)}
						disabled={!isIngredientEditor}
						handleCharacteristicChange={(_checked: boolean, elementId: string) => {
							handlers.changeCharacteristic({
								characteristic: elementId as Characteristic,
								dialog: {
									invalidDensity: alertInvalidDensity,
									shouldRecalculate: shouldRecalculate,
									successfulRecalculation: successfulRecalculation,
								},
							});
						}}
					/>
				</div>
			}
		/>
	);
};
